module.exports = {
  resolve: function (...args) {
    return args.join('/');
  },
  join: function (...args) {
    return args.join('/');
  },
  basename: function (str) {
    return str.split('/').pop();
  },
  dirname: function (str) {
    return str.split('/').slice(0, -1).join('/');
  },
};
